import { showError, useDestinationsStore, useNuxtApp, useRoute } from '#imports'

export async function useLoadDestination () {
  const { params } = useRoute()
  const app = useNuxtApp()
  const destinationsStore = useDestinationsStore()

  const destinationUpdated = destinationsStore.destination.data.permalink !== params.destination
  if (destinationUpdated) {
    try {
      await destinationsStore.loadDestination(params.destination)
    } catch (e) {
      if (! e.response || (e.response && e.response.status !== 404)) { app.$sentry.captureException(e) }
    }
  }
  if (! destinationsStore.destination.data.id) {
    return showError({ statusCode: 404, statusMessage: 'Destination not found' })
  }

  return { destinationUpdated }
}
